import clsx from 'clsx';
import type { CSSProperties, ReactNode } from 'react';

import heroBg from 'src/assets/images/oth/oth-logo-green.png';

import s from './Oth360Banner.module.scss';

type Props = {
  title: ReactNode;
  actions?: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export function Oth360Banner({ title, actions, className, style }: Props) {
  return (
    <header
      className={clsx(s.hero, className)}
      style={
        {
          ...style,
          ['--oth360-hero-bg' as string]: `url(${heroBg})`,
        } as CSSProperties
      }
    >
      <div className={s.heroInner}>
        <div className={s.heroTitle}>{title}</div>
        {actions ? <div className={s.heroActions}>{actions}</div> : null}
      </div>
    </header>
  );
}
